import MyHoursListPageActionTypes from './my-hours-list-page-action-types';
import axios from 'axios';
import ValidationError from '../../../utils/validation-error';
import ForbiddenError from '../../../utils/forbidden-error';
import { sortingToStringWithSubstitutes } from '../../../utils/objectUtils';

export const loadMyHoursListPage = () => async(dispatch, getState) => {
  const { take } = getState().myGeneralCompetencyHoursListPage;
  dispatch(findMyHours({ skip: 0, take }));
};

export const findMyHours = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: MyHoursListPageActionTypes.LOAD_MY_HOURS_LIST_PAGE_START });
  const state = getState().myGeneralCompetencyHoursListPage;
  const query = {
    skip: payload ? payload.skip : state.skip,
    limit: payload ? payload.take : state.take,
    sorting: sortingToStringWithSubstitutes(state.sorting, [
      { originalName: 'occurredAt', substituteName: 'OccurredAt' },
      { originalName: 'minutes', substituteName: 'Minutes' },
      { originalName: 'status', substituteName: 'Status' }
    ])
  };
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const [hours, summary] = await Promise.all([
      api.get('api/my_general_competency_hours', query, state.cancelToken.token),
      api.get('api/my_general_competency_hours/summary', null, state.cancelToken.token)
    ]);
    dispatch({
      type: MyHoursListPageActionTypes.LOAD_MY_HOURS_LIST_PAGE_END,
      payload: {
        hours: hours ? hours.data.map(h => ({ ...h, occurredAt: h.occurredAt ? new Date(h.occurredAt.substring(0, 10) + 'T12:00:00') : null })) : [],
        total: hours ? hours.total : 0,
        summary: summary || null,
        skip: payload ? payload.skip : state.skip,
        take: payload ? payload.take : state.take
      }
    });
  } catch (error) {
    if (error instanceof ForbiddenError) {
      dispatch({
        type: MyHoursListPageActionTypes.LOAD_MY_HOURS_LIST_PAGE_END,
        payload: { accessDeniedMessage: error.message }
      });
    } else if (!(error instanceof axios.Cancel)) {
      dispatch({ type: MyHoursListPageActionTypes.LOAD_MY_HOURS_LIST_PAGE_END });
      throw error;
    }
  }
};

export const sortMyHours = (payload) => (dispatch) => {
  dispatch({
    type: MyHoursListPageActionTypes.SORT_MY_HOURS_LIST,
    payload: payload
  });
  dispatch(findMyHours());
};

export const toggleEnterCodeDialog = (isVisible) => ({
  type: MyHoursListPageActionTypes.TOGGLE_ENTER_CODE_DIALOG,
  payload: { isVisible }
});

export const submitCode = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: MyHoursListPageActionTypes.SUBMIT_CODE_START });
  try {
    const result = await api.post('api/general_competency_hours/scan', { token: payload.code });
    if (result?.alreadyRegistered) {
      dispatch({
        type: MyHoursListPageActionTypes.SUBMIT_CODE_END,
        payload: { alreadyRegistered: true }
      });
      return;
    }
    dispatch({ type: MyHoursListPageActionTypes.TOGGLE_ENTER_CODE_DIALOG, payload: { isVisible: false } });
    dispatch(findMyHours());
  } catch (error) {
    let validationResult = null;
    if (error instanceof ValidationError) {
      validationResult = {
        errorMessage: error.message,
        errors: error.errors
      };
    }
    dispatch({ type: MyHoursListPageActionTypes.SUBMIT_CODE_END, payload: { validationResult } });
  }
};
